import React from "react";

import { ImageLoader } from "../img/ImageLoader";
import { plantCategoryEnums } from "../../utils/enums";

import Paper from "@mui/material/Paper";


import "./UiCards.css";

function CardsPlant({plantEnum, isSmall}: any) {
  const style = {
    paper: {
      width: isSmall ? "49%" : "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "20px",
      padding: '0px',
    },
  };
  return (
    <Paper sx={style.paper}>
      <div className="PlantCard">
        <div className="PlantCardImageOuter">
          <ImageLoader
            imgUrl={plantEnum.image === "" ? plantEnum.icon : plantEnum.image}
            radiusStyle={"5px"}
          />
        </div>
        <div className="PlantCardDetails">
          <p className="PlantCardTitle">
            {plantEnum.name}{" "}
            <span
              style={{ fontSize: "70%", opacity: 0.85, fontStyle: "italic" }}
            >
              {plantEnum.scientificName}
            </span>
          </p>
          <p className="PlantCardSubTitle">{plantEnum.subtitle}</p>
          <p className="PlantCardCategory">
            {plantCategoryEnums.find(
              (element) => element.value === plantEnum.category
            )?.name || "Unknown Category"}
          </p>
        </div>
        <div className="PlantCardEnd"></div>
      </div>
    </Paper>
  );
}

export default CardsPlant;
